module.exports = __webpack_public_path__ + "img/globe-icon.30538c3e.svg";